import React, { useEffect } from 'react';
import ackFibo from '../../../assets/nach-cancellation/ackFibo.svg';
import ackBgImg from '../../../assets/nach-cancellation/ackBgImg.svg';
import ackMobileBgImg from '../../../assets/nach-cancellation/ackMobileBgImg.svg';
import GrayCrossIcon from '../../../assets/apply-refer-code/gray-cross-icon.svg';
import { useNavigate } from 'react-router';

const AckScreen = () => {
  const navigate = useNavigate();
  useEffect(() => {
    history.pushState(null, document.title, location.href);
    window.addEventListener('popstate', function (event) {
      history.pushState(null, document.title, location.href);
    });
  }, []);
  return (
    <>
      <div className="bg-[#fff7e3] h-full flex flex-col justify-between">
        <div
          className="fixed top-6 right-6 lg:top-[18%] lg:right-[4%] cursor-pointer z-10"
          onClick={() => navigate('/dashboard')}
        >
          <img
            src={GrayCrossIcon}
            className="bg-[#F6F5F1] p-[7px] rounded-full"
          />
        </div>
        <div className="h-full">
          <div className="text-center relative  w-full z-[1] h-full flex items-center justify-center">
            <div>
              <div className="">
                <img
                  className="w-2/6 short1:w-[inherit] inline-block"
                  src={ackFibo}
                  alt="ackFibo"
                />
              </div>
              <div className="text-text-dark text-lg short1:text-3xl lg:!text-2xl mt-6">
                We have received{' '}
                <br className="hidden short1:block lg:!hidden" /> your request{' '}
              </div>
              <div className="text-text-primary text-sm lg:text-base mt-3 px-6 lg:px-0">
                Cancel your Auto debit. We are processing the same with your
                bank. You will receive a <br className="hidden lg:block" />{' '}
                confirmation message post the request is completed.
              </div>
            </div>
          </div>

          <div className="absolute left-0 top-0 w-full">
            <img
              className="hidden lg:block h-full w-full"
              src={ackBgImg}
              alt="DesktopBackgroundImg"
            />
            <img
              className="block lg:hidden h-full w-full"
              src={ackMobileBgImg}
              alt="MobileBackgroundImg"
            />
          </div>
        </div>

        <div className="bg-white px-8 py-7 lg:py-10 w-full z-[1] pb-20 short2:pb-24 lg:!pb-10">
          <h3 className="text-text-primary text-lg mb-3">Please note</h3>
          <p className="text-text-secondary text-xs lg:text-base mb-3">
            1. Until your bank cancels your Auto debit, it will be used for
            auto-payment of any pending EMI(s)
          </p>

          <p className="text-text-secondary text-xs lg:text-base">
            2. Once your bank cancels your Auto debit, please make pending EMI
            payments on/before due date, directly from our app using various
            options available
          </p>
        </div>
      </div>
    </>
  );
};

export default AckScreen;
